import { m } from '@hub/messages';
import { definePageRoute } from '@hub/router/definePageRoute';
import { type DomainParents, defineDomainRoutes } from '@hub/router/domain-routes';
import { OrdersPaths } from './route.paths';

export default function createOrdersRoutes(parents: DomainParents) {
  const ordersRoute = definePageRoute(parents, {
    path: OrdersPaths.orders,
    title: m.orders_page_title,
    description: m.orders_page_description,
    page: () => import('./Orders.page'),
    flag: 'page-orders',
    quickAction: {
      to: OrdersPaths.orders.path,
      icon: 'package',
      title: m.orders_page_title,
      subline: m.orders_quick_action_subline,
      surfaces: ['home-account', 'device-actions'],
      order: 37,
    },
  });

  return defineDomainRoutes({
    authenticated: [ordersRoute] as const,
    public: [] as const,
  });
}
